/*
 * File: AppointmentPage.js
 * Project: mp-mobile-app
 *
 * Created by Vamsi Sureddy
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles loading a single appointment. Displays the progress spinner.
 */
import React, { useState, useEffect } from "react";
import UIProgress from "components/ui/UIProgress";
import Router from "components/Router";
import EditAppointmentButton from "../components/EditAppointmentButton";
import PatientStore from "services/patients/store/PatientStore";
import AppointmentDetailRoutes from "../components/AppointmentDetailRoutes";
import Preferences from "services/preferences/Store";
import ApptStore from "services/appointments/store/DataStore";
import { useStore } from "utils/useStore";
import AlertStore from "services/patients/alerts/Store";
import PatientAlerts from "services/patients/alerts/views/AlertsBar";
import { RouteComponentProps } from "react-router";

type Props = RouteComponentProps<{ appointmentId: string }>;

const AppointmentPage = ({ match }: Props) => {
  const [loading, setLoading] = useState(true);
  const preferences = useStore(Preferences);
  const appointmentStore = useStore(ApptStore);
  const patientStore = useStore(PatientStore);
  const alertStore = useStore(AlertStore);

  useEffect(() => {
    (async () => {
      const apptId = Number(match.params.appointmentId);

      if (
        apptId !== appointmentStore.selectedAppointmentId() ||
        apptId == null ||
        apptId < 0
      ) {
        await appointmentStore.fetchAppointment(apptId);
      }

      if (
        patientStore.patientModel?.patientId === undefined ||
        patientStore.patientModel?.patientId <= 0
      ) {
        await patientStore.find(preferences);
      }

      await alertStore.fetchAlerts(patientStore.patientModel?.patientId);
      setLoading(false);
    })();
  }, [match.params.appointmentId, preferences, appointmentStore, patientStore]);

  if (loading) return <UIProgress />;

  return (
    <React.Fragment>
      <PatientAlerts />
      <Router routes={AppointmentDetailRoutes} />
      <EditAppointmentButton editAppt={appointmentStore.editAppt} />
    </React.Fragment>
  );
};

export default AppointmentPage;
